'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_display_Spinner_Spinner = require('../../display/Spinner/Spinner.cjs.js');
const components_forms_TextInput_TextInput = require('../TextInput/TextInput.cjs.js');
const utils_formatAriaAttrKeys = require('../../../utils/formatAriaAttrKeys.cjs.js');
const theme_Animation = require('../../../theme/Animation.cjs.js');
require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("TypeaheadInput", {
  clearSelectionButton: react.css`
    ${styleMixins_reset.interactiveReset};
    align-items: center;
    color: var(--zds-stroke-stronger);
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;

    &:hover,
    &:focus {
      color: var(--zds-text-weaker);
      transition: ${theme_Animation.Animation.transitionValue};
    }
  `
});
const ClearSelectionButton = ({ clearSelection }) => {
  return react.jsx(
    "button",
    { type: "button", css: Styles.clearSelectionButton, onClick: clearSelection, title: "Clear Selection", "data-zds": true },
    react.jsx(components_display_Icon_Icon.Icon, { canAcceptPointerEvents: false, name: "formXCircle", size: 20 })
  );
};
const InputIcon = (props) => {
  return props.renderIcon && props.selectedItem ? props.renderIcon(props.selectedItem, props.getLabelForItem) : (
    // Search icon also handles the use case where an item has been
    // selected but props.renderIcon has not been specified.
    react.jsx(components_display_Icon_Icon.Icon, { name: "navSearch", size: props.iconSize })
  );
};
const TypeaheadInput = React.forwardRef((_a, ref) => {
  var { size = "medium" } = _a, props = tslib_es6.__rest(_a, ["size"]);
  const showClearSelectionButton = props.selectedItem && !props.isDisabled;
  return react.jsx(
    components_forms_TextInput_TextInput.TextInput,
    Object.assign({}, utils_formatAriaAttrKeys.camelCaseAriaAttrs(props.getInputProps({
      // @ts-ignore this is valid, but downshift TS types are wrong
      ariaLabelledBy: props.ariaLabelledBy,
      autoComplete: props.autoComplete,
      onFocus: props.onFocus,
      onKeyDown: props.onKeyDown
    })), { "aria-label": props["aria-label"], autoComplete: "off", canClickIconAfter: showClearSelectionButton, disabledText: props.disabledText, isDisabled: props.isDisabled, isErrored: props.isErrored, placeholder: props.placeholder, onBlur: props.onBlur, ref, renderIconAfter: ({ iconSize, isFocused, isHovered }) => showClearSelectionButton ? react.jsx(ClearSelectionButton, { clearSelection: props.clearSelection, isFocused, isHovered }) : props.iconEndName && react.jsx(components_display_Icon_Icon.Icon, { name: props.iconEndName, size: iconSize }), renderIconBefore: ({ iconSize }) => {
      if (props.isBusy) {
        return react.jsx(
          "span",
          { style: { width: iconSize }, "data-zds": true },
          react.jsx(components_display_Spinner_Spinner.Spinner, null)
        );
      }
      return react.jsx(InputIcon, Object.assign({}, props, { iconSize }));
    }, size })
  );
});

exports.TypeaheadInput = TypeaheadInput;
//# sourceMappingURL=TypeaheadInput.cjs.js.map
